<template>
  <div class="navbar">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'navbar',
    components: {},
    data () {
      return {}
    },
    computed: {
      sidebar () {
      }
    }
  }
</script>



// WEBPACK FOOTER //
// NavBar.vue?017387ac